var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.heading || _vm.button.url
      ? _c("div", { staticClass: "px-ogs" }, [
          _c(
            "div",
            { staticClass: "py-6 lg:py-10 flex justify-between items-center" },
            [
              _vm.heading
                ? _c("div", { staticClass: "text-md lg:text-xl" }, [
                    _vm._v(_vm._s(_vm.heading)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.button.url
                ? _c(
                    "a",
                    {
                      staticClass: "link flex items-center space-x-2",
                      attrs: {
                        href: _vm.button.url,
                        target: _vm.button.target,
                      },
                    },
                    [
                      _c("span", { staticClass: "underline" }, [
                        _vm._v(_vm._s(_vm.button.customText || "View all")),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-5" },
                        [_c("IconArrowRight")],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "slide-wrapper w-full relative" },
      _vm._l(_vm.items, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "slide lg:absolute lg:left-0 lg:top-0 lg:h-124",
            class: [
              `text-${item.colour[0].textColour}`,
              `slide-${index + 1}`,
              index <= _vm.activeIndex ? "slide--has-moved" : "",
              _vm.windowIsResizing
                ? "transition-none"
                : "transition-transform duration-1000",
            ],
            style: {
              backgroundColor: item.colour[0].colour
                ? item.colour[0].colour
                : "#f0f0f0",
            },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "text-md lg:text-xl px-ogs pb-ogs lg:py-10 lg:px-8 flex flex-col h-full justify-between",
                class: {
                  "opacity-50 lg:opacity-30 cursor-pointer hover:opacity-70 transition-opacity duration-300":
                    index !== _vm.activeIndex,
                },
                on: {
                  click: function ($event) {
                    return _vm.handleClick(index)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex justify-between items-center lg:items-baseline h-18 lg:h-auto",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center lg:items-start space-x-3 sm:space-x-5 mr-4",
                      },
                      [
                        _c("div", [_vm._v(_vm._s(index + 1))]),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "fade" } }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: index == _vm.activeIndex,
                                  expression: "index == activeIndex",
                                },
                              ],
                              staticClass: "hidden lg:block",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "link",
                                  attrs: {
                                    href: `/colours?colour=${item.colour[0].slug}`,
                                  },
                                },
                                [_vm._v(_vm._s(item.colour[0].title))]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "lg:hidden leading-tight" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: `/colours?colour=${item.colour[0].slug}`,
                              },
                            },
                            [_vm._v(_vm._s(item.colour[0].title))]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "fade" } }, [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                index == _vm.activeIndex &&
                                index + 1 !== _vm.items.length,
                              expression:
                                "index == activeIndex && index + 1 !== items.length",
                            },
                          ],
                          staticClass:
                            "w-10 link hidden lg:block focus:opacity-60",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleClick(index + 1)
                            },
                          },
                        },
                        [
                          _c("IconArrowRightAlt"),
                          _vm._v(" "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Next Colour"),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "lg:hidden focus:outline-none" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "19",
                            height: "19",
                            viewBox: "0 0 19 19",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: index !== _vm.activeIndex,
                                expression: "index !== activeIndex",
                              },
                            ],
                            attrs: {
                              d: "M9.295 18.5899V-7.7453e-05",
                              stroke: "currentColor",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M18.59 9.29492H0",
                              stroke: "currentColor",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: index == _vm.activeIndex,
                          expression: "index == activeIndex",
                        },
                      ],
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex space-x-5" },
                        [
                          _vm.testPotProductId
                            ? _c(
                                "ProductColourTestPot",
                                {
                                  attrs: {
                                    loading: _vm.isLoading,
                                    "test-pot": _vm.getTestPot(
                                      item.colour[0].id
                                    ),
                                    source: "popular_colours_block",
                                    "paint-colour": item.colour[0].colour || "",
                                    "text-colour":
                                      item.colour[0].textColour || "",
                                    "colour-title": item.colour[0].title || "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        item.cartButtonText ||
                                          `${item.colour[0].title} Test Pot`
                                      ) +
                                      "\n                - $" +
                                      _vm._s(
                                        _vm.getTestPot(item.colour[0].id)
                                          ? _vm.getTestPot(item.colour[0].id)
                                              .salePrice
                                          : 6
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.button.url
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-soft",
                                  class: {
                                    "btn-soft--alt":
                                      item.colour[0].textColour === "white",
                                  },
                                  attrs: {
                                    href: item.button.url,
                                    target: item.button.target,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.button.customText) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }